__turbopack_context__.v({
  "accessibilityStatement": "PlasmicAccessibilityStatementBanner-module__yDQQMW__accessibilityStatement",
  "col": "PlasmicAccessibilityStatementBanner-module__yDQQMW__col",
  "head": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head",
  "head2": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head2",
  "head3": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head3",
  "head4": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head4",
  "head5": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head5",
  "head6": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head6",
  "head7": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head7",
  "head8": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head8",
  "head9": "PlasmicAccessibilityStatementBanner-module__yDQQMW__head9",
  "line": "PlasmicAccessibilityStatementBanner-module__yDQQMW__line",
  "link": "PlasmicAccessibilityStatementBanner-module__yDQQMW__link",
  "p": "PlasmicAccessibilityStatementBanner-module__yDQQMW__p",
  "rawLi": "PlasmicAccessibilityStatementBanner-module__yDQQMW__rawLi",
  "rawUl": "PlasmicAccessibilityStatementBanner-module__yDQQMW__rawUl",
  "row": "PlasmicAccessibilityStatementBanner-module__yDQQMW__row",
  "section": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section",
  "section2": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section2",
  "section3": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section3",
  "section4": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section4",
  "section5": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section5",
  "section6": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section6",
  "section7": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section7",
  "section8": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section8",
  "section9": "PlasmicAccessibilityStatementBanner-module__yDQQMW__section9",
  "text": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text",
  "text10": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text10",
  "text2": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text2",
  "text3": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text3",
  "text4": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text4",
  "text5": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text5",
  "text6": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text6",
  "text7": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text7",
  "text8": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text8",
  "text9": "PlasmicAccessibilityStatementBanner-module__yDQQMW__text9",
  "title": "PlasmicAccessibilityStatementBanner-module__yDQQMW__title",
  "wrapper": "PlasmicAccessibilityStatementBanner-module__yDQQMW__wrapper",
});
